import type React from "react";
import { useState } from "react";
import { Play } from "lucide-react";

interface VideoPlayerProps {
    thumbnail: string;
    url: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ url, thumbnail }) => {
    const [videoActivated, setVideoActivated] = useState(false);

    const handleThumbnailClick = () => {
        setVideoActivated(true);
    };

    return (
        <div className="space-y-4">
            <div className="rounded-lg overflow-hidden bg-black aspect-video relative">
                {!videoActivated ? (
                    <div
                        className="cursor-pointer w-full h-full relative"
                        onClick={handleThumbnailClick}
                    >
                        <img
                            src={thumbnail || "/placeholder.svg"}
                            alt="Video thumbnail"
                            className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 flex items-center justify-center bg-black/30 hover:bg-black/40 transition-colors">
                            <div className="bg-white/90 rounded-full p-4 shadow-lg">
                                <Play className="h-8 w-8 text-gray-800 fill-current" />
                            </div>
                        </div>
                    </div>
                ) : (
                    <video
                        className="w-full h-full"
                        controls
                        autoPlay
                        poster={thumbnail}
                        src={url}
                    >
                        Your browser does not support the videos.
                    </video>
                )}
            </div>
        </div>
    );
};

export default VideoPlayer;
